
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../../../components/Theme";

const SettingsTab = () => {
  const navigate = useNavigate();
  const { darkMode, toggleModes } = useTheme();


  const handleUpdateClicked = () => navigate("../update");

  const buttonClasses = {
    light: " text-black",
    dark: " text-white",
  };



  return (
    <div className="p-4 min-h-screen">
      <h1 className="text-xl font-bold mb-4">Settings</h1>
      <p className="mb-4">
        You can modify most of your settings from the button below.
      </p>
      <div className="flex flex-col items-start">
        <button
          onClick={handleUpdateClicked}
          className="bg-cyan-700 text-white px-4 py-2 rounded mb-2 hover:bg-cyan-700"
        >
          Update Settings
        </button>
        <p className="mb-2">
          You can choose a theme for your screen
        </p>

        {/* Toggle bar code for switching the theme for the website */}
        <label className="inline-flex items-center cursor-pointer">
          <input type="checkbox" value="" className="sr-only peer " />
          <div onClick={toggleModes} className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-cyan-600"></div>
          <span className={`ms-3 text-sm font-medium text-gray-900 dark:text-gray-300 ${darkMode ? buttonClasses.dark : buttonClasses.light
            }`}>
            {darkMode ? "Set to Light" : "Set to Dark"}</span>
        </label>

      </div>
    </div>
  );
};

export default SettingsTab;


